import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import routes, { formatRoute } from 'config/routes'
import { CurrencyContext } from 'contexts'
import PropTypes from 'prop-types'
import React from 'react'
import { Button, ListGroup } from 'react-bootstrap'
import { FormattedDate, FormattedNumber } from 'react-intl'
import { Link } from 'react-router-dom'
import { confirm } from 'utils'

function Expense(props) {
  const { onDelete, expense } = props
  const currency = React.useContext(CurrencyContext)
  const editExpenseRoute = formatRoute(routes.expenseEdit, { id: expense.id })

  const deleteExpense = async () => {
    const msg = 'Are you sure you want to delete this expense?'
    try {
      await confirm(msg)
      onDelete(expense.id)
    } catch (err) {
      // no-op
    }
  }

  return (
    <ListGroup.Item className="expense d-flex flex-column">
      <div className="d-flex flex-row justify-content-between">
        <div className="details d-flex flex-column">
          <h5 className="location">{expense.description}</h5>
          <p className="date text-muted mb-1">
            <FontAwesomeIcon
              icon={['far', 'calendar-alt']}
              fixedWidth
              className="mr-1 text-success"
            />
            <FormattedDate
              value={expense.date}
              day="numeric"
              month="short"
              year="numeric"
              timeZone="utc"
            />
          </p>
        </div>
        <div className="d-flex flex-column justify-content-around">
          <div className="actions d-flex justify-content-end">
            <Button
              variant="warning"
              size="sm"
              as={Link}
              to={{
                pathname: editExpenseRoute,
                state: {
                  expense,
                },
              }}
            >
              <FontAwesomeIcon icon={['far', 'pencil']} fixedWidth />
            </Button>
            {onDelete && (
              <Button
                variant="danger"
                size="sm"
                className="ml-1"
                onClick={deleteExpense}
              >
                <FontAwesomeIcon icon={['far', 'trash']} fixedWidth />
              </Button>
            )}
          </div>
          <div className="earnings loss mt-3">
            <sup>
              <FontAwesomeIcon icon={['far', 'minus']} />
              <FontAwesomeIcon icon={currency.icon} fixedWidth />
            </sup>
            <FormattedNumber
              // eslint-disable-next-line
              style="decimal"
              minimumFractionDigits={2}
              maximumFractionDigits={2}
              value={Math.abs(expense.amount)}
            />
          </div>
        </div>
      </div>
    </ListGroup.Item>
  )
}

Expense.propTypes = {
  onDelete: PropTypes.func,
  expense: PropTypes.object.isRequired,
}

export default Expense
